import React from "react";

import SupportRequestForm from "components/legal/SupportRequestForm";
import LegalPage from "views/legal/LegalPage";

export const SUPPORT_EMAIL = "destek@destinasyon360.com";
export const SUPPORT_WEB = "https://destinasyon360.com";

const contactChannels = [
  {
    icon: "ni ni-email-83",
    label: "Destek e-postası",
    value: SUPPORT_EMAIL,
    href: `mailto:${SUPPORT_EMAIL}?subject=Destinasyon%20360%20Destek`,
    hint: "Hesap, giriş, rezervasyon ve gizlilik talepleri için yazın.",
  },
  {
    icon: "ni ni-world-2",
    label: "Web sitesi",
    value: "destinasyon360.com",
    href: SUPPORT_WEB,
    hint: "Güncel duyurular ve platform bilgileri.",
  },
  {
    icon: "ni ni-time-alarm",
    label: "Yanıt süresi",
    value: "1–3 iş günü",
    hint: "Hafta içi 09:00–18:00 (TSI). Acil güvenlik konularında öncelik verilir.",
  },
];

const sections = [
  {
    title: "Uygulama ve geliştirici",
    paragraphs: [
      "Destinasyon 360; Karadeniz destinasyonlarını, işletmeleri, kampanyaları ve seyahat deneyimlerini keşfetmenizi sağlayan mobil ve web platformudur.",
    ],
    items: [
      "Uygulama adı: Destinasyon 360",
      "Geliştirici: Karadeniz Dernekleri Konfederasyonu",
      "Destek dili: Türkçe (İngilizce talepler için de yanıt verilmeye çalışılır)",
      "Platformlar: iOS, Android ve web",
    ],
  },
  {
    title: "Sık sorulan sorular",
    items: [
      "Giriş yapamıyorum: E-posta ve şifrenizi kontrol edin. Şifrenizi unuttuysanız uygulamadaki «Şifremi unuttum» akışını kullanın veya destek e-postasına kayıtlı e-posta adresinizi yazın.",
      "Hesap oluşturma: Uygulamada «Kayıt ol» ile e-posta ve şifre belirleyebilirsiniz. Kayıt için geçerli bir e-posta adresi gerekir.",
      "Misafir kullanım: Keşfet bölümünün bir kısmı giriş olmadan kullanılabilir; harita, fırsatlar ve profil için giriş veya kayıt gerekir.",
      "Rezervasyon ve işletmeler: Rezervasyon talepleri ilgili işletmeye iletilir. İptal veya değişiklik için uygulama içinden veya destek e-postasından bize ulaşın.",
      "Bildirimler ve uyarılar: Profil > Uyarılarım bölümünden bildirim tercihlerinizi yönetebilirsiniz.",
      "Veri ve gizlilik: Kişisel verilerinizle ilgili talepler için Gizlilik Politikası ve Kullanıcı Gizliliği sayfalarına bakın veya destek e-postasından «Gizlilik talebi» konu satırıyla yazın.",
      "Hesap silme: Profil ayarlarından hesabınızı silebilir veya destek@destinasyon360.com adresine «Hesap silme» konulu e-posta gönderin; kimliğinizi doğrulamak için kayıtlı e-postanızı belirtin.",
    ],
  },
  {
    title: "Mobil uygulama desteği",
    items: [
      "Uygulamayı App Store veya Google Play üzerinden güncel sürüme yükseltin.",
      "İnternet bağlantınızı kontrol edin ve uygulamayı yeniden başlatın.",
      "Sorun devam ederse cihaz modeli, işletim sistemi sürümü ve ekran görüntüsü ile destek e-postasına yazın.",
      "TestFlight veya beta sürümlerde sorun yaşıyorsanız build numarasını mesajınıza ekleyin.",
    ],
  },
  {
    title: "Gizlilik ve yasal bağlantılar",
    paragraphs: [
      "Destek talepleriniz yalnızca talebinizi çözmek ve hizmeti sunmak amacıyla işlenir. Ayrıntılar için aşağıdaki politika sayfalarını inceleyin.",
    ],
    items: [
      "Gizlilik Politikası: /privacy-policy",
      "Kullanıcı Gizliliği: /user-privacy",
    ],
  },
  {
    title: "Erişilebilirlik ve geri bildirim",
    paragraphs: [
      "Platformu geliştirmek için öneri, hata bildirimi veya iş birliği taleplerinizi yukarıdaki destek formu veya destek e-postası üzerinden iletebilirsiniz. Geri bildirimleriniz için teşekkür ederiz.",
    ],
  },
];

const SupportPage = () => (
  <LegalPage
    title="Destek"
    subtitle="Destinasyon 360 kullanıcıları için yardım, iletişim ve sık sorulan sorular."
    lastUpdated="21 Mayıs 2026"
    intro="Bu sayfa App Store ve Google Play destek bağlantısı olarak sunulmaktadır. Hesap, teknik sorun, rezervasyon veya gizlilik konularında aşağıdaki formu doldurabilir veya iletişim kanallarını kullanabilirsiniz."
    afterIntro={<SupportRequestForm />}
    contactChannels={contactChannels}
    sections={sections}
    relatedLinks={[
      { to: "/privacy-policy", label: "Gizlilik Politikası" },
      { to: "/user-privacy", label: "Kullanıcı Gizliliği" },
    ]}
  />
);

export default SupportPage;
